import { useState } from 'react';
import axios from 'axios';

export default function EditModal({ user, onClose, onSaved }) {
  const [form, setForm] = useState({
    nome:            user.nome            || '',
    cpf:             user.cpf             || '',
    data_nascimento: user.data_nascimento ? user.data_nascimento.slice(0, 10) : '',
    nome_mae:        user.nome_mae        || '',
    municipio:       user.municipio       || '',
    telefone:        user.telefone        || '',
    tipo:            user.tipo            || '',
    email:           user.email           || '',
  });
  const [saving, setSaving] = useState(false);
  const [erro,   setErro]   = useState('');

  const set    = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const upper  = (k) => (e) => set(k, e.target.value.toUpperCase());

  const salvar = async () => {
    setSaving(true); setErro('');
    try {
      await axios.patch(`/api/users/${user.id}/dados`, form);
      onSaved();
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao salvar');
    } finally { setSaving(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-header">
          <h3 className="modal-title">✏️ Editar Colaborador</h3>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="alert alert-info" style={{ marginBottom: 12, fontSize: 12 }}>
          <strong>Login:</strong> {user.login} &nbsp;|&nbsp; <strong>Perfil:</strong> {user.role}
        </div>

        {erro && <div className="alert alert-danger">{erro}</div>}

        <div className="grid-2">
          <div className="field-group" style={{ gridColumn: '1/-1' }}>
            <label className="r-label">NOME COMPLETO</label>
            <input className="r-input" value={form.nome} onChange={upper('nome')} />
          </div>
          <div className="field-group">
            <label className="r-label">CPF</label>
            <input className="r-input" value={form.cpf} onChange={e => set('cpf', e.target.value)} placeholder="000.000.000-00" />
          </div>
          <div className="field-group">
            <label className="r-label">DATA DE NASCIMENTO</label>
            <input type="date" className="r-input" value={form.data_nascimento} onChange={e => set('data_nascimento', e.target.value)} />
          </div>
          <div className="field-group" style={{ gridColumn: '1/-1' }}>
            <label className="r-label">NOME DA MÃE</label>
            <input className="r-input" value={form.nome_mae} onChange={upper('nome_mae')} />
          </div>
          <div className="field-group">
            <label className="r-label">MUNICÍPIO</label>
            <input className="r-input" value={form.municipio} onChange={upper('municipio')} />
          </div>
          <div className="field-group">
            <label className="r-label">TELEFONE</label>
            <input className="r-input" value={form.telefone} onChange={e => set('telefone', e.target.value)} placeholder="(65) 99999-9999" />
          </div>
          <div className="field-group" style={{ gridColumn: '1/-1' }}>
            <label className="r-label">TIPO</label>
            <select className="r-select" value={form.tipo} onChange={e => set('tipo', e.target.value)}>
              <option value="">Selecione...</option>
              <option value="PREFEITO">Prefeito</option>
              <option value="VEREADOR">Vereador</option>
              <option value="LIDERANCA">Liderança</option>
              <option value="OUTROS">Outros</option>
            </select>
          </div>
          <div className="field-group" style={{ gridColumn: '1/-1' }}>
            <label className="r-label">E-MAIL</label>
            <input type="email" className="r-input" value={form.email}
              onChange={e => set('email', e.target.value.toLowerCase())}
              placeholder="email@exemplo.com" />
            <span style={{ fontSize:11, color:'#888', marginTop:3, display:'block' }}>
              📧 Utilizado para recuperação de senha
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button onClick={salvar} disabled={saving} className="btn" style={{ flex: 1 }}>
            {saving ? 'Salvando...' : '💾 Salvar Alterações'}
          </button>
          <button onClick={onClose} className="btn btn-outline" style={{ borderColor: 'var(--danger)', color: 'var(--danger)' }}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
